import React from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { Box, Button } from '@material-ui/core'

import { MenuButton, Permitted } from 'components'

import constants from 'constants/index'
import { routes } from 'Routes'

const ActionButtons = ({ monitoringManagementPmc }) => {
  const history = useHistory()

  const redirectToShow = () =>
    history.push(
      reverse(routes.pmc.show, {
        monitoringManagementPmcId: monitoringManagementPmc?.id,
      }),
    )

  const redirectToEdit = () =>
    history.push(
      reverse(routes.pmc.edit, {
        monitoringManagementPmcId: monitoringManagementPmc?.id,
      }),
    )

  return (
    <Box display="flex" justifyContent="flex-end">
      <MenuButton>
        <Permitted tag={constants.permissions.MONITORING_MANAGEMENT_PMC.MANAGE}>
          <Button color="secondary" fullWidth onClick={redirectToEdit}>
            Editar
          </Button>
        </Permitted>
        <Button color="secondary" fullWidth onClick={redirectToShow}>
          Visualizar
        </Button>
      </MenuButton>
    </Box>
  )
}

export default ActionButtons
